module.exports = __webpack_public_path__ + "static/media/1.f4c4b377.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16460/1.jpg
// module id = 558
// module chunks = 0